import { useEffect, useState } from 'react';
import { ProjectApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectWithAssigneesDto } from '../../../commonTypes/acs';

const useHttpGetProjectByIdOnMount = (id?: string) => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const [project, setProject] = useState<ProjectWithAssigneesDto>();
    const [isProjectReady, setIsProjectReady] = useState<boolean>(false);

    const exec = () => {
        if (id) {
            const { exec, abort } = projectApi.getProjectById({
                params: { id },
                onSuccess: res => {
                    setProject(res.body);
                },
                onError: error => console.log(error),
                onFinally: () => setIsProjectReady(true),
            });
            exec();
            return abort;
        }
    };
    useEffect(() => {
        if (id) {
            exec();
        }
    }, [id, exec]);

    return { project, isProjectReady, exec };
};

export default useHttpGetProjectByIdOnMount;
